import {combineEpics} from 'redux-observable';
import usersEpics from './subscribersEpic';
import groupsEpics from './groupsEpic';
import filtersEpic from './filtersEpic';

export default combineEpics(usersEpics, groupsEpics, filtersEpic);
